module.exports = __webpack_public_path__ + "static/img/investment.6d401e1d.png";